import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../../utils/constants';
import { OptionsMenu } from '../OptionMenu';
import { LogoLink } from '../../Logo';
import { CJRLogo, LogoPositions } from '../../CJRLogo';

export type SidebarProps = { foo?: string };

export const Sidebar = ({ foo }: SidebarProps) => {
  const location = useLocation();
  const editPattern = new RegExp(ROUTES.users.edit('\\d+'));
  const hideSidebar =
    location.pathname === ROUTES.home ||
    location.pathname === ROUTES.users.create ||
    location.pathname === ROUTES.users.me ||
    editPattern.test(location.pathname);

  if (hideSidebar) return null;

  return (
    <div
      className={clsx(
        'hidden md:flex flex-col',
        'gap-2 w-min px-6 py-2',
        'max-h-screen'
      )}
    >
      <LogoLink width={130} height={130} />

      <div className="scroll-thin" style={{ overflow: 'overlay' }}>
        <OptionsMenu />
      </div>
      <CJRLogo logoPosition={LogoPositions.SIDEBAR} />
    </div>
  );
};
